import _ from 'lodash';

const spritAndTrim = (value: string, separator: string) =>
  _.map(_.split(value, separator), (item) => _.trim(item));

export default spritAndTrim;
